import { createFileRoute } from '@tanstack/react-router';
import { InscriptionGate } from '@/features/subscription/shared/InscriptionGate';
import InscriptionAccessibilityPage from '@/features/subscription/inscription-accessibility-page/InscriptionAccessibilityPage';
import { ensureOnboardingProgressLoaded } from '@/features/account/onboarding/shared/ensure-onboarding-progress.loader';

export const Route = createFileRoute('/vagas/$jobId_/inscricao/acessibilidade')({
  component: () => (
    <InscriptionGate>
      <InscriptionAccessibilityPage />
    </InscriptionGate>
  ),
  loader: ({ context }) => ensureOnboardingProgressLoaded(context),
});
